<template>
  <paginated-data-table
    ref="table"
    :headers="headers"
    :search="search"
    :query="query"
    :custom-items-per-page="10"
    query-name="highlightedOffers"
    :queryVariables="queryVariables"
    :default-table-sort-by="defaultTableSortBy"
    :default-table-sort-desc="defaultTableSortDesc"
    :graphql-uri="$microservicesUrls['fedGateway']"
  >
    <template v-slot:item="{ item }">
      <tr class="cursor-pointer" @click="toggleHighlight(item)">
        <td>
          <v-simple-checkbox :value="selectedHighlightsIds.includes(item.id)" color="primary" :ripple="false" @input="toggleHighlight(item)" />
        </td>

        <td class="nowrap-row">
          <v-tooltip v-model="showTooltipTitle[item.id]" max-width="250" top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <router-link v-if="item.status === 'FINISHED'" class="link" :to="{ path: getHighlightRouteLink(item.id) }" target="_blank">
                  {{ getFormatedText(item.title, 24) }}
                </router-link>
                <span v-else>{{ getFormatedText(item.title, 24) }}</span>
              </span>
            </template>
            <span>{{ item.title }}</span>
          </v-tooltip>
        </td>

        <td class="nowrap-row">
          <v-tooltip v-model="showTooltipDescription[item.id]" max-width="250" top>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ getFormatedText(item.description, 48) }}</span>
            </template>
            <span>{{ item.description }}</span>
          </v-tooltip>
        </td>

        <td>
          {{
            item.initialDate && item.finalDate
              ? `${DateTime.fromISO(item.initialDate.toString()).toFormat('dd/MM/yyyy')} - ${DateTime.fromISO(item.finalDate.toString()).toFormat(
                  'dd/MM/yyyy'
                )}`
              : '-'
          }}
        </td>
      </tr>
    </template>
  </paginated-data-table>
</template>

<script>
import PaginatedDataTable from '@/components/PaginatedDataTable'
import { QUERY_GET_HIGHLIGHTED_OFFERS } from '@/modules/mobile/destaques/graphql'
import truncate from 'lodash/truncate'
import { DateTime } from 'luxon'
import { statusCampaignArrayValidator } from '@/helpers/propValidators.js'

export default {
  name: 'SelectHighlightsTable',
  components: {
    PaginatedDataTable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    singleCheckbox: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    status: {
      type: Array,
      default: () => [],
      validator: statusCampaignArrayValidator,
    },
    defaultTableSortBy: {
      type: String,
      default: '',
    },
    defaultTableSortDesc: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showTooltipTitle: {},
    showTooltipDescription: {},
    selectedHighlightsIds: [],
    DateTime: DateTime,
  }),
  computed: {
    query() {
      return QUERY_GET_HIGHLIGHTED_OFFERS
    },
    queryVariables() {
      return {
        search: this.search,
        status: this.status,
        franchise: this.isFranchisee,
      }
    },
    selectedHighlights: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          value: '',
          sortable: false,
          width: '5%',
        },
        {
          text: 'Nome',
          value: 'title',
          width: '30%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '30%',
        },
        {
          text: 'Data de validade',
          value: 'final_date',
          width: '35%',
        },
      ]
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
  },
  watch: {
    selectedHighlights: {
      deep: true,

      handler(value) {
        this.selectedHighlightsIds = value.map(({ id }) => id)
      },
    },
  },
  mounted() {
    if (this.selectedHighlights) this.selectedHighlightsIds = this.selectedHighlights.map(({ id }) => id)
  },
  methods: {
    getHighlightRouteLink(id) {
      return `/campanhas/destaques/resultados/${id}`
    },
    toggleHighlight(toggledHighlight) {
      if (this.singleCheckbox) {
        this.selectedHighlights = [toggledHighlight]
        return
      }
      const selectedHighlightsDelta = this.selectedHighlights.filter((highlight) => highlight.id !== toggledHighlight.id)

      if (selectedHighlightsDelta.length === this.selectedHighlights.length) {
        selectedHighlightsDelta.push(toggledHighlight)
      }
      this.selectedHighlights = selectedHighlightsDelta
    },
    getFormatedText(text, length) {
      return truncate(text, {
        length,
        separator: ' ',
      })
    },
  },
}
</script>

<style lang="scss">
.link-color {
  color: $marca-0-l40 !important;
}
</style>
